import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

export default function AccordionUsage() {
  return (
    <div style={{paddingRight:'75%'}}>

<Accordion >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">About</Typography>
        </AccordionSummary>
        <AccordionDetails>
            

      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">About the Tech Demo</Typography>
        </AccordionSummary>
        <AccordionDetails>
          This tech demo uses the Unity Engine to display 3D objects and render entire game worlds. It is a lower quality version so that it may run within as many browsers as possible. Higher quality interactive experiences require streaming services and thus are more costly. 3D models are made in Blender and textures and typography are made in Adobe Products.
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span">Capabilities</Typography>
        </AccordionSummary>
        <AccordionDetails>
            <ul>
            <li>
            With our bespoke experiences users can purchase real world items directly through our games
            </li>
            <li> We  integrate analytics reporting systems.</li>
            <li>
            Since our bespoke branded experiences are written in the Unity Engine we are able to do anything that video games can do. 
            </li>
            <li>
            Multiplayer game modes
            </li>
            <li>
            Token gating with NFTs 
            </li>
            <li>
                DeFi
            </li>



            </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span">Uses</Typography>
        </AccordionSummary>
        <AccordionDetails>
            <ul>
                <li>
                increase engagement
                </li>
                <li>
                increase conversions   
                </li>
                <li>
                excite your customers
                </li>
                <li>
                build loyalty
                </li>
                <li>
                build relationships
                </li>
                <li>
                directly collect user information and analytics
                </li>
                <li>
                reduce your marketing cost
                </li>
            </ul>
        </AccordionDetails>
      </Accordion>
        </AccordionDetails>
      </Accordion>


     
    </div>
  );
}
